"use client";

import type { ReactNode } from "react";
import { HStack, Text, VStack } from "@chakra-ui/react";
import type { SourcedWhere } from "@/generated/fastapi";
import ProfileReviewSearchInput from "./ProfileReviewSearchInput";

type ProfileReviewScopeControlsProps = {
  controls?: ReactNode;
  onLongPressResetSearchSettings?: () => void;
  onOpenSearchSettings: () => void;
  onResetSearchQuery: () => void;
  onSearchQueryChange: (value: string) => void;
  searchAriaLabel: string;
  searchPlaceholder: string;
  searchQuery: string;
  searchSettingsHighlighted?: boolean;
  searchSettingsLabel?: string;
  searchSettingsResetEnabled?: boolean;
  title?: string;
  voiceSearchSource?: SourcedWhere;
};

export default function ProfileReviewScopeControls({
  controls,
  onLongPressResetSearchSettings,
  onOpenSearchSettings,
  onResetSearchQuery,
  onSearchQueryChange,
  searchAriaLabel,
  searchPlaceholder,
  searchQuery,
  searchSettingsHighlighted = false,
  searchSettingsLabel = "Search settings",
  searchSettingsResetEnabled = false,
  title = "Review scope",
  voiceSearchSource = "studio",
}: ProfileReviewScopeControlsProps) {
  return (
    <VStack align="stretch" spaceY="2">
      <HStack justify="space-between" align="center" gap="3">
        <Text fontWeight="bold">{title}</Text>
      </HStack>

      {controls}

      <HStack gap="2" align="center">
        <ProfileReviewSearchInput
          ariaLabel={searchAriaLabel}
          onLongPressResetSearchSettings={onLongPressResetSearchSettings}
          onOpenSearchSettings={onOpenSearchSettings}
          onQueryChange={onSearchQueryChange}
          onResetQuery={onResetSearchQuery}
          placeholder={searchPlaceholder}
          query={searchQuery}
          searchSettingsHighlighted={searchSettingsHighlighted}
          searchSettingsLabel={searchSettingsLabel}
          searchSettingsResetEnabled={searchSettingsResetEnabled}
          voiceSearchSource={voiceSearchSource}
        />
      </HStack>
    </VStack>
  );
}
